// removed by extract-text-webpack-plugin
module.exports = {"flyout":"CwFlyout-flyout","flyoutTopLeft":"CwFlyout-flyoutTopLeft","flyoutTopRight":"CwFlyout-flyoutTopRight","flyoutBottomLeft":"CwFlyout-flyoutBottomLeft","flyoutBottomRight":"CwFlyout-flyoutBottomRight"};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwflyout/CwFlyout.scss
// module id = 1008
// module chunks = 10